import { MenuContent } from '@tunasong/ui-lib'
import type { UIExtensionItemMenuProps } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { entityMenuGroups, useEntityMenuItems } from '../chrome/entity-menu.hook.js'
import { MenuGroups } from '../chrome/menu-groups.js'

/**
 * The entity list/card item menu. Renders the popup content of the host's
 * canonical `<Menu>` (the host owns the `<MenuTrigger>`), so agent-command
 * flyout submenus get Base UI's full keyboard contract (GH #1496).
 *
 * Dialogs render beside the popup, not inside it: an item closes the menu and
 * opens its dialog, which then lives on its own open state.
 *
 * @note expensive (one entity-menu hook per instance) — hosts mount it on first open.
 */
export const EntityActionsMenu: FC<UIExtensionItemMenuProps> = props => {
  const { entity, anchorEl, onClose } = props

  const { groups, dialogs } = useEntityMenuItems({ entity, onClose, onCloseMenu: onClose })

  return (
    <>
      <MenuContent anchorEl={anchorEl}>
        <MenuGroups groups={entityMenuGroups(groups)} />
      </MenuContent>
      {...dialogs}
    </>
  )
}

export default EntityActionsMenu
